import type { Winner } from '@src/@types/ozonPrizeWinners';
import { HeaderTitle } from '@src/components/OctoberPrizeDraw/HeaderTitle';
import { OtherWinners } from '@src/components/OctoberPrizeDraw/OctoberPrizeDrawPrizeWinner/components/OtherWinners';

import styles from './styles.module.scss';

type Props = {
  currentWinner: Winner;
};

const WINNER_HEADING_DATA = {
  title: 'Поздравляем! Вы выиграли приз!',
  subTitle: 'Мы свяжемся с вами в ближайшее время',
};

export const WinnerBlock = ({ currentWinner }: Props) => (
  <div className={styles.wrapper}>
    <HeaderTitle
      className={styles.headingWrapper}
      title={WINNER_HEADING_DATA.title}
      subTitle={WINNER_HEADING_DATA.subTitle}
    />
    <OtherWinners items={[currentWinner]} />
  </div>
);
